import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import { openPdfInNewTab } from "../Utils/otherFunctions";
import {
  getItemSubmitSuccessMsg,
  getItemDeleteSuccessMsg,
  getItemCreateSuccessMsg,
  getItemEditSuccessMsg,
} from "../Constant/Message";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const StafContext = createContext();

export const useStaf = () => useContext(StafContext);

export const StafProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getStaf: () =>
      axiosInstance
        .get("sipeg/staf/")
        .catch((err) => handleError(err, "GET Staf")),

    getUserList: () =>
      axiosInstance
        .get("sipeg/staf/")
        .catch((err) => handleError(err, "GET User")),

    getGroupStaf: () =>
      axiosInstance
        .get("sipeg/group-staf/")
        .catch((err) => handleError(err, "GET Group Staf")),
    
    getGroupByID: (id) =>
      axiosInstance
        .get(`sipeg/group-staf/${id}`)
        .catch((err) => handleError(err, "GET Group Staf")),

    getStatusStaf: () =>
      axiosInstance
        .get("sipeg/status-staf/")
        .catch((err) => handleError(err, "GET Status Staf")),

    getTipeStaf: () =>
      axiosInstance
        .get("sipeg/tipe-staf/")
        .catch((err) => handleError(err, "GET Tipe Staf")),

    getFotoProfilByID: (id) =>
      axiosInstance
        .get(`sipeg/foto-profil/${id}`, { responseType: "blob" })
        .catch((err) => handleError(err, "GET Foto Profil")),

    getAbsensiByStafIdandDate: (stafId, date) =>
      axiosInstance
        .get(`sipeg/absensi/${stafId}/${date}`)
        .catch((err) => handleError(err, "GET Absen")),

    getAbsensiDetailByStafIdandDate: (stafId, date) =>
      axiosInstance
        .get(`sipeg/absensi/detail/${stafId}/${date}`)
        .catch((err) => handleError(err, "GET Absen")),

    createStaf: (formData) =>
      axiosInstance
        .post("sipeg/staf/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => handleSuccess(res, getItemSubmitSuccessMsg("Staf")))
        .catch((err) => handleError(err, "POST Staf")),

    checkUsernameLDAP: (formData) =>
      axiosInstance
        .post(`auth/check-username/`, formData)
        .catch((err) => handleError(err, "POST Username")),

    postSlipGaji: (formData) =>
      axiosInstance
        .post(`slipgaji/cetak/`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          openPdfInNewTab(res);
          return handleSuccess(res, getItemCreateSuccessMsg("Slip Gaji"));
        })
        .catch((err) => handleError(err, "POST Slip Gaji")),

    updateStaf: (id, formData) =>
      axiosInstance
        .put(`sipeg/staf/${id}`, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => handleSuccess(res, getItemEditSuccessMsg("Staf")))
        .catch((err) => handleError(err, "PUT Staf")),

    deleteStaf: (id) =>
      axiosInstance
        .delete(`sipeg/staf/${id}`)
        .then((res) => handleSuccess(res, getItemDeleteSuccessMsg("Staf")))
        .catch((err) => handleError(err, "DELETE Staf")),
  };

  return <StafContext.Provider value={api}>{children}</StafContext.Provider>;
};

export default StafContext;
